"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("div", {
    staticClass: "side-nav",
    class: {
      "is-black": _vm.currentSection >= 1
    }
  }, _vm._l(_vm.navItems, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "nav-item",
      class: {
        active: _vm.currentSection === index
      },
      on: {
        click: function click($event) {
          return _vm.scrollToSection(index);
        }
      }
    }, [_vm._m(0, true), _c("div", {
      staticClass: "nav-text"
    }, [_vm._v(_vm._s(item))])]);
  }), 0), _c("div", {
    staticClass: "page-box section",
    attrs: {
      "data-section": "0"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E9%95%96%E7%A5%9E%E7%AE%A1%E5%AE%B6banner.png"
    }
  }), _c("div", {
    staticClass: "page-title"
  }, [_vm._m(1), _c("div", {
    staticClass: "title-sub"
  }, [_vm._v("助力危运企业营收、利润倍增")]), _c("div", {
    staticClass: "title-sub margin-bottom-30"
  }, [_vm._v("让业务拓客有方 让车辆调度有术 让老板生财有道")]), _c("div", {
    staticClass: "title-sub title-sub-btn margin-bottom-90",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.TryNow.apply(null, arguments);
      }
    }
  }, [_vm._v("立即体验 "), _c("i", {
    staticClass: "el-icon-right"
  })]), _vm._m(2)])]), _c("div", {
    staticClass: "section section-2",
    attrs: {
      "data-section": "1"
    }
  }, [_c("div", {
    staticClass: "section-content"
  }, [_c("div", {
    staticClass: "section-content-title"
  }, [_vm._v("客户开发功能模块，让客户拓客有方")]), _c("div", {
    staticClass: "feature-box"
  }, [_c("div", {
    staticClass: "feature-item",
    class: {
      active: _vm.activeFeature === 0
    },
    on: {
      click: function click($event) {
        _vm.activeFeature = 0;
      }
    }
  }, [_c("img", {
    staticClass: "feature-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E6%99%BA%E8%83%BD%E6%8B%93%E5%AE%A2%402x.png"
    }
  }), _c("div", {
    staticClass: "feature-title"
  }, [_vm._v("智能拓客")])]), _c("div", {
    staticClass: "feature-item",
    class: {
      active: _vm.activeFeature === 1
    },
    on: {
      click: function click($event) {
        _vm.activeFeature = 1;
      }
    }
  }, [_c("img", {
    staticClass: "feature-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E6%BD%9C%E5%AE%A2%E6%8E%A8%E8%8D%90%402x.png"
    }
  }), _c("div", {
    staticClass: "feature-title"
  }, [_vm._v("潜客推荐")])]), _c("div", {
    staticClass: "feature-item",
    class: {
      active: _vm.activeFeature === 2
    },
    on: {
      click: function click($event) {
        _vm.activeFeature = 2;
      }
    }
  }, [_c("img", {
    staticClass: "feature-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E6%8B%9B%E6%8A%95%E6%A0%87%402x.png"
    }
  }), _c("div", {
    staticClass: "feature-title"
  }, [_vm._v("招投标")])]), _c("div", {
    staticClass: "feature-item",
    class: {
      active: _vm.activeFeature === 3
    },
    on: {
      click: function click($event) {
        _vm.activeFeature = 3;
      }
    }
  }, [_c("img", {
    staticClass: "feature-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/AI%E6%89%BE%E5%9B%9E%E7%A8%8B%E8%B4%A7%402x.png"
    }
  }), _c("div", {
    staticClass: "feature-title"
  }, [_vm._v("AI找回程货")])])]), _c("div", {
    staticClass: "feature-display-area"
  }, [_c("transition", {
    attrs: {
      name: "fade-transform",
      mode: "out-in"
    }
  }, [_c("div", {
    key: _vm.activeFeature,
    staticClass: "display-container"
  }, [_c("img", {
    staticClass: "main-display-img",
    attrs: {
      src: _vm.featureContents[_vm.activeFeature].img
    }
  })])])], 1)])]), _vm._m(3), _c("div", {
    staticClass: "section section-4",
    attrs: {
      "data-section": "3"
    }
  }, [_c("div", {
    staticClass: "section-content"
  }, [_c("div", {
    staticClass: "section-content-title"
  }, [_vm._v("TMS功能模块，让老板生财有道")]), _c("div", {
    staticClass: "tms-container"
  }, [_c("div", {
    staticClass: "tms-sidebar"
  }, _vm._l(_vm.sideMenus, function (menu, index) {
    return _c("div", {
      key: index,
      staticClass: "sidebar-item",
      class: {
        active: _vm.activeMenu === index
      },
      on: {
        click: function click($event) {
          _vm.activeMenu = index;
        }
      }
    }, [_c("img", {
      staticClass: "menu-icon",
      attrs: {
        src: menu.icon
      }
    }), _c("span", {
      staticClass: "menu-label"
    }, [_vm._v(_vm._s(menu.label))])]);
  }), 0), _c("div", {
    staticClass: "tms-content-wrapper"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 0,
      expression: "activeMenu === 0"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(4)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 1,
      expression: "activeMenu === 1"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(5)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 2,
      expression: "activeMenu === 2"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(6)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 3,
      expression: "activeMenu === 3"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(7)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 4,
      expression: "activeMenu === 4"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(8)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeMenu === 5,
      expression: "activeMenu === 5"
    }],
    staticClass: "tms-flow-panel"
  }, [_vm._m(9)])])])])]), _vm._m(10), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible,
      width: "600px",
      "show-close": false,
      "close-on-click-modal": true,
      "custom-class": "logistics-contact-dialog"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "dialog-wrapper"
  }, [_c("i", {
    staticClass: "el-icon-close custom-close",
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }), _c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%95%96%E7%A5%9E%E7%AE%A1%E5%AE%B6code.png",
      width: "100%",
      alt: "扫码"
    }
  })])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nav-icon"
  }, [_c("div", {
    staticClass: "dot"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-box"
  }, [_c("span", {
    staticClass: "title-item"
  }, [_vm._v("镖神管家/")]), _c("span", {
    staticClass: "title-item item_right"
  }, [_vm._v("智慧运输管理系统")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-sub"
  }, [_c("span", {
    staticClass: "title-item"
  }, [_vm._v("起步价/")]), _c("span", {
    staticClass: "title-item item_right"
  }, [_vm._v("¥19,800.00"), _c("span", [_vm._v("起")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-3",
    attrs: {
      "data-section": "2"
    }
  }, [_c("div", {
    staticClass: "content-display-area"
  }, [_c("div", {
    staticClass: "section-content-title"
  }, [_vm._v("车辆调度功能模块，让车辆调度有术")]), _c("div", {
    staticClass: "card-row flex-3"
  }, [_c("div", {
    staticClass: "info-card"
  }, [_c("div", {
    staticClass: "card-tag"
  }, [_vm._v("运力地图")]), _c("ul", {
    staticClass: "card-list"
  }, [_c("li", [_c("span", {
    staticClass: "text-blue"
  }, [_vm._v("10000+")]), _vm._v("运力实时在线接单 车型多、资质全")]), _c("li", [_c("span", {
    staticClass: "text-green"
  }, [_vm._v("5分钟")]), _vm._v("响应 哪里有业务，哪里就有车")])]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/AISAAS%E8%BF%90%E5%8A%9B%E5%9C%B0%E5%9B%BE.png",
      alt: "运力地图配图"
    }
  })])]), _c("div", {
    staticClass: "info-card"
  }, [_c("div", {
    staticClass: "card-tag"
  }, [_vm._v("AI外呼")]), _c("ul", {
    staticClass: "card-list"
  }, [_c("li", [_vm._v("AI批量联系、智能筛选适合承运的运力")]), _c("li", [_vm._v("节省调度时间精力 车辆匹配效率翻番")])]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/04-%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%882P.docx%402x.png",
      alt: "AI外呼配图"
    }
  })])]), _c("div", {
    staticClass: "info-card"
  }, [_c("div", {
    staticClass: "card-tag"
  }, [_vm._v("熟车管理")]), _c("ul", {
    staticClass: "card-list"
  }, [_c("li", [_vm._v("常用外调车分类管理 好运力积少成多")]), _c("li", [_vm._v("配车效率更高、服务质量更好")])]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E7%86%9F%E8%BD%A6%E7%AE%A1%E7%90%86%402x.png",
      alt: "熟车管理配图"
    }
  })])])]), _c("div", {
    staticClass: "card-row flex-1"
  }, [_c("div", {
    staticClass: "info-card full-width"
  }, [_c("div", {
    staticClass: "card-header"
  }, [_c("span", {
    staticClass: "card-tag"
  }, [_vm._v("雷达找车")]), _c("span", {
    staticClass: "header-desc"
  }, [_vm._v("AI雷达扫描"), _c("span", {
    staticClass: "text-green"
  }, [_vm._v("200公里内")]), _vm._v("符合车型、资质等要求的运力 实时配车 效率高更精准")])]), _c("div", {
    staticClass: "steps-box"
  }, [_c("div", {
    staticClass: "step-item"
  }, [_c("div", {
    staticClass: "step-title"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" 第一步：筛选信息")]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E9%9B%B7%E8%BE%BE%E6%89%BE%E8%BD%A61%402x.png",
      alt: "第一步配图"
    }
  })])]), _c("div", {
    staticClass: "step-item"
  }, [_c("div", {
    staticClass: "step-title"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" 第二步：雷达找车")]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E9%9B%B7%E8%BE%BE%E6%89%BE%E8%BD%A62%402x.png",
      alt: "第二步配图"
    }
  })])]), _c("div", {
    staticClass: "step-item"
  }, [_c("div", {
    staticClass: "step-title"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" 第三步：找车结果")]), _c("div", {
    staticClass: "img-placeholder"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E9%9B%B7%E8%BE%BE%E6%89%BE%E8%BD%A63%402x.png",
      alt: "第三步配图"
    }
  })])])])])]), _c("div", {
    staticClass: "case-study-container"
  }, [_c("div", {
    staticClass: "case-header"
  }), _c("div", {
    staticClass: "case-card-wrapper"
  }, [_c("div", {
    staticClass: "case-main-card"
  }, [_c("div", {
    staticClass: "case-columns"
  }, [_c("div", {
    staticClass: "case-col"
  }, [_c("h3", {
    staticClass: "col-title"
  }, [_vm._v("客户案例一：辽宁某某物流")]), _c("div", {
    staticClass: "info-group"
  }, [_c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("基本情况")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("100+台车，年营收1亿元")])]), _c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("使用需求")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("找回程货 客户开发")])]), _c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("使用时长")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("6个月")])])]), _c("div", {
    staticClass: "divider"
  }, [_vm._v("使用情况")]), _c("div", {
    staticClass: "result-group"
  }, [_c("div", {
    staticClass: "result-row"
  }, [_c("span", {
    staticClass: "bubble-tag"
  }, [_vm._v("找回程货")]), _c("span", {
    staticClass: "result-val"
  }, [_vm._v("营收提升16%，成本下降26%")])]), _c("div", {
    staticClass: "result-row"
  }, [_c("span", {
    staticClass: "bubble-tag"
  }, [_vm._v("开发客户")]), _c("span", {
    staticClass: "result-val"
  }, [_vm._v("长期稳定客户新增8个，货运量提升21%")])])])]), _c("div", {
    staticClass: "case-col"
  }, [_c("h3", {
    staticClass: "col-title"
  }, [_vm._v("客户案例二：宁夏某某物流")]), _c("div", {
    staticClass: "info-group"
  }, [_c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("基本情况")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("自有180台车，年营收2亿元")])]), _c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("使用需求")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("使用TMS系统")])]), _c("div", {
    staticClass: "info-row"
  }, [_c("span", {
    staticClass: "tag"
  }, [_vm._v("使用时长")]), _c("span", {
    staticClass: "val"
  }, [_vm._v("5个月")])])]), _c("div", {
    staticClass: "divider"
  }, [_vm._v("使用情况")]), _c("div", {
    staticClass: "result-group"
  }, [_c("div", {
    staticClass: "result-row"
  }, [_c("span", {
    staticClass: "bubble-tag secondary"
  }, [_vm._v("管理流程")]), _c("span", {
    staticClass: "result-val"
  }, [_vm._v("内部管理流程显著提升 沟通成本稳步下降")])]), _c("div", {
    staticClass: "result-row"
  }, [_c("span", {
    staticClass: "bubble-tag secondary"
  }, [_vm._v("运输路线")]), _c("span", {
    staticClass: "result-val"
  }, [_vm._v("运输路线更合理 综合成本下降30%")])])])])])])])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/1%E6%B5%81%E7%A8%8B%E5%9B%BE.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/22%E7%BB%8F%E8%90%A5%E5%88%86%E6%9E%90.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/33%E8%BF%90%E8%BE%93%E8%AE%A2%E5%8D%95.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/4%E8%BF%87%E7%A8%8B%E7%AE%A1%E6%8E%A7.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/5%E8%B7%AF%E7%BA%BF%E5%88%9B%E5%BB%BA.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "panel-header"
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/66%E5%A4%9A%E7%AB%AF%E4%BA%92%E8%81%94.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bottom-img"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E8%BD%AF%E4%BB%B6%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-AIsaas/%E6%89%AB%E7%A0%81.png",
      alt: "扫码"
    }
  })]);
}];
render._withStripped = true;